import { inject, observer } from 'mobx-react';
import React from 'react';
import { format } from 'date-fns'
import {
  Button,
  InputSearch,
  List,
  ListItem,
  ListItemText,
  withStateCard,
  Toast,
  ToastType,
  ListItemTitle,
  ListItemActions,
  Card,
  TabComponent,
  TabPanel,
  CardActions
} from '../../Components';
import ChangePage from './Components/ChangePage'
import {
  MonografiaStore,
  MONOGRAFIA_STORE,
  AGENDAMENTO_STORE,
  AlunoStore,
  ALUNO_STORE,
  PreProjetoStore,
  PREPROJETO_STORE,
  SituacaoDoPreProjeto,
  PROFESSOR_STORE,
  ProfessorStore
} from '../../Store';
import { RouteComponentProps } from 'react-router';
import styled from 'styled-components';
import { Tag } from '../../Components/Tag/Tag';
import Tutorial_Funcionario from "../../Utils/Tutorial/Manual_do_portal_do_TCC_Funcionario.pdf";

interface IState {
  value: string;
}

interface IProps extends RouteComponentProps {
  [MONOGRAFIA_STORE]: MonografiaStore;
  [ALUNO_STORE]: AlunoStore
  [PREPROJETO_STORE]: PreProjetoStore
  [PROFESSOR_STORE]: ProfessorStore
}

const MonografiasCardWithState = withStateCard(List);
const AlunosCardWithState = withStateCard(List);
const PreProjetoCardWithState = withStateCard(List);
const ProfessorCardWithState = withStateCard(List);

const StyledText = styled.span`
  padding: 5px;
`;

const StyledTutorialButton = styled(Button)`
  margin-left: auto;
`;

const StyledTags = styled.div`
  flex-direction: row;
`;

const StyledCardActions = styled(CardActions)`
  border-top: none;
`;

@inject(MONOGRAFIA_STORE, AGENDAMENTO_STORE, ALUNO_STORE, PREPROJETO_STORE, PROFESSOR_STORE)
@observer
class ListaMonografiasPage extends React.Component<IProps, IState> {
  inputSearchTimeout = 0;
  scrollTimeout = 0;
  tabRef = React.createRef<TabComponent>();
  tabPreProjetoRef = React.createRef<TabComponent>();

  constructor(props: IProps) {
    super(props);

    this.tabRef = React.createRef<TabComponent>();

    this.state = {
      value: ''
    };
    this.getMonografias();
    this.getAlunos();
    this.getPreProjetos();
    this.getPreProjetosRecusados();
    this.getProfessores();
    this.getListaParametrosPreProjeto();
  }

  getMonografias = () => {
    const monografiaStore = this.props[MONOGRAFIA_STORE];
    monografiaStore.getMonografiasQuePossuemDeposito();
  };

  getListaParametrosPreProjeto = () => {
    const store = this.props[PREPROJETO_STORE]
    store.buscarListaDeParametros()
  };

  getAlunos = () => {
    const alunoStore = this.props[ALUNO_STORE];
    alunoStore.getAlunos();
  };

  getPreProjetos = () => {
    const store = this.props[PREPROJETO_STORE]
    store.buscarTodosPreProjetosFuncionario()
  }

  getPreProjetosRecusados = () => {
    const store = this.props[PREPROJETO_STORE]
    store.buscarTodosPreProjetosFuncionarioRecusados()
  }

  getProfessores = () => {
    const professorStore = this.props[PROFESSOR_STORE]
    professorStore.getProfessoresComPaginacao()
  }

  executarTrigger = () => {
    const abaAtiva = this.tabRef.current!.state.activeChild
    const abaAtivaDoPreProjeto = this.tabPreProjetoRef.current!.state.activeChild

    if (abaAtiva === 'DepósitosAceitos') setTimeout(this.triggerChangeMonografias, 1000)
    if (abaAtiva === 'Alunos') setTimeout(this.triggerChangeAlunos, 1000)
    if (abaAtivaDoPreProjeto === 'Pré-ProjetosAceitos/Pendentes') setTimeout(this.triggerChangePreProjetos, 1000)
    if (abaAtivaDoPreProjeto === 'Pré-ProjetosRecusados') setTimeout(this.triggerChangePreProjetosRecusados, 1000)
    if (abaAtiva === 'Professores') setTimeout(this.triggerChangeProfessores(), 1000)
  }

  limparSearch = () => {
    this.setState({ value: '' })

    this.executarTrigger()
  }

  searchInfos = (e: React.ChangeEvent<HTMLInputElement>) => {
    clearTimeout(this.inputSearchTimeout)
    const value = e.target.value
    this.setState({ value })

    this.executarTrigger()
  };

  triggerChangeMonografias = () => {
    const { value } = this.state
    const monografiaStore = this.props[MONOGRAFIA_STORE]

    monografiaStore.update('monografiaListQuery', 'search', value)
    monografiaStore.update('monografiaListQuery', 'page', 1)

    monografiaStore.getMonografiasQuePossuemDeposito(false)
  };

  triggerChangeAlunos = () => {
    const { value } = this.state
    const alunoStore = this.props[ALUNO_STORE]

    alunoStore.update('alunoListQuery', 'search', value)
    alunoStore.update('alunoListQuery', 'page', 1)

    alunoStore.getAlunos(false)
  };

  triggerChangeProfessores = () => {
    const { value } = this.state
    const professorStore = this.props[PROFESSOR_STORE]

    professorStore.updateObject('professorListQuery', 'search', value)
    professorStore.updateObject('professorListQuery', 'page', 1)

    professorStore.getProfessoresComPaginacao(false)
  };

  triggerChangePreProjetos = () => {
    const { value } = this.state
    const preProjetoStore = this.props[PREPROJETO_STORE]

    preProjetoStore.updateObject('preProjetosListQuery', 'search', value)
    preProjetoStore.updateObject('preProjetosListQuery', 'page', 1)

    preProjetoStore.buscarTodosPreProjetosFuncionario(false)
  }

  triggerChangePreProjetosRecusados = () => {
    const { value } = this.state
    const preProjetoStore = this.props[PREPROJETO_STORE]

    preProjetoStore.updateObject('preProjetosRecusadosListQuery', 'searchRecusados', value)
    preProjetoStore.updateObject('preProjetosRecusadosListQuery', 'pageRecusados', 1)

    preProjetoStore.buscarTodosPreProjetosFuncionarioRecusados(false)
  }

  changePageMonografia = (change: number) => {
    const monografiaStore = this.props[MONOGRAFIA_STORE];
    const { monografiaListQuery } = monografiaStore;

    monografiaStore.update(
      'monografiaListQuery',
      'page',
      monografiaListQuery.page + change
    );
    this.getMonografias();
  };

  changePageAluno = (change: number) => {
    const alunoStore = this.props[ALUNO_STORE];
    const { alunoListQuery } = alunoStore;

    alunoStore.update(
      'alunoListQuery',
      'page',
      alunoListQuery.page + change
    );
    this.getAlunos();
  };

  changePageProfessor = (change: number) => {
    const professorStore = this.props[PROFESSOR_STORE];
    const { professorListQuery } = professorStore;

    professorStore.updateObject(
      'professorListQuery',
      'page',
      professorListQuery.page + change
    );
    this.getProfessores();
  };

  changePagePreProjeto = (change: number) => {
    const store = this.props[PREPROJETO_STORE];
    const { preProjetosListQuery } = store;

    store.updateObject(
      'preProjetosListQuery',
      'page',
      preProjetosListQuery.page + change
    );
    this.getPreProjetos();
  };

  changePagePreProjetoRecusados = (change: number) => {
    const store = this.props[PREPROJETO_STORE];
    const { preProjetosRecusadosListQuery } = store;

    store.updateObject(
      'preProjetosRecusadosListQuery',
      'pageRecusados',
      preProjetosRecusadosListQuery.pageRecusados + change
    );
    this.getPreProjetosRecusados();
  };

  resetAgendamento = () => {
    const agendamentoStore = this.props[AGENDAMENTO_STORE];
    agendamentoStore.resetAgendamento();
  };

  onResumeClick = () => {
    window.open(Tutorial_Funcionario);
  }

  render() {
    const monografiaStore = this.props[MONOGRAFIA_STORE];
    const agendamentoStore = this.props[AGENDAMENTO_STORE];
    const alunoStore = this.props[ALUNO_STORE];
    const preProjetoStore = this.props[PREPROJETO_STORE]
    const professorStore = this.props[PROFESSOR_STORE]

    const {
      monografias,
      monografiaListState,
      monografiaListQuery
    } = monografiaStore;
    const { agendamentoRealizado } = agendamentoStore;

    const { alunos, alunoListState, alunoListQuery } = alunoStore;

    const {
      preProjetoListState,
      preProjetoListStateRecusados,
      parametrosListState,
      preProjetosAprovadosPendentes,
      parametrosList,
      preProjetosRecusados,
      preProjetosListQuery,
      preProjetosRecusadosListQuery
    } = preProjetoStore

    const { professores, professoresState, professorListQuery } = professorStore

    return (
      <>
        <StyledTutorialButton
          type="button"
          color="primaryLightColor"
          onClick={this.onResumeClick}
        >
          Tutorial de Uso
        </StyledTutorialButton>
        {agendamentoRealizado && (
          <Toast type={ToastType.success}>
            <StyledText>Agendamento realizado</StyledText>
          </Toast>
        )}
        <InputSearch
          placeholder='Pesquise por nome ou matricula do aluno, nome do professor ou titulo'
          value={this.state.value}
          onChange={this.searchInfos}
        />
        <Card>
          <TabComponent onTabComponentClick={this.limparSearch} ref={this.tabRef} activeChild={'Pré-Projetos'}>
            <TabPanel titulo='Pré-Projetos' >
              <TabComponent onTabComponentClick={this.limparSearch} activeChild='Pré-ProjetosAceitos/Pendentes' ref={this.tabPreProjetoRef} >
                <TabPanel titulo='Pré-Projetos' subtitulo='Aceitos/Pendentes'>
                  <PreProjetoCardWithState
                    state={preProjetoListState}
                    noContent='Nenhum Pré-Projeto encontrado'
                  >
                    {preProjetosAprovadosPendentes && preProjetosAprovadosPendentes
                    .filter(p => 
                      p.parametroPreProjetoId === parametrosList[0].id
                    )
                    .map((p, i) => (
                      <ListItem key={i}
                        onClick={() => {
                          window.location.pathname = `${this.props.match.path}/preprojetos/${p.id}`;
                        }}>
                        <ListItemTitle>{p.aluno.matricula} - {p.aluno.nome.toUpperCase()}</ListItemTitle>
                        <ListItemText>{p.titulo}</ListItemText>
                        <ListItemActions>
                          <StyledTags>
                            {(() => {
                              switch (p.situacao) {
                                case SituacaoDoPreProjeto.aprovado:
                                  return <Tag color='approvedColor'>Orientação aceita</Tag>;
                                case SituacaoDoPreProjeto.pendente:
                                  return <Tag color='primaryColor'>Seleção pendente</Tag>;
                                case SituacaoDoPreProjeto.recusado:
                                  return <Tag color='errorColor'>Orientação não aceita</Tag>;
                                default:
                                  return <Tag color='primaryColor'>Seleção pendente</Tag>;
                              }
                            })()}
                          </StyledTags>
                        </ListItemActions>
                      </ListItem>
                    ))}
                  </PreProjetoCardWithState>
                  <ChangePage
                    page={preProjetosListQuery.page}
                    pageSize={preProjetosListQuery.pageSize}
                    length={preProjetosAprovadosPendentes && preProjetosAprovadosPendentes.length}
                    changePage={this.changePagePreProjeto} />
                </TabPanel>
                <TabPanel titulo='Pré-Projetos' subtitulo='Recusados'>
                  <PreProjetoCardWithState
                    state={preProjetoListStateRecusados}
                    noContent='Nenhum Pré-Projeto encontrado'
                  >
                    {preProjetosRecusados && preProjetosRecusados
                    .filter(p => 
                      p.parametroPreProjetoId === parametrosList[0].id
                    )
                    .map((p, i) => (
                      <ListItem key={i}
                        onClick={() => {
                          window.location.pathname = `${this.props.match.path}/preprojetos/${p.id}`;
                        }}>
                        <ListItemTitle>{p.aluno.matricula} - {p.aluno.nome.toUpperCase()}</ListItemTitle>
                        <ListItemText>{p.titulo}</ListItemText>
                        <ListItemActions>
                          <StyledTags>
                            {(() => {
                              switch (p.situacao) {
                                case SituacaoDoPreProjeto.aprovado:
                                  return <Tag color='approvedColor'>Orientação aceita</Tag>;
                                case SituacaoDoPreProjeto.pendente:
                                  return <Tag color='primaryColor'>Seleção pendente</Tag>;
                                case SituacaoDoPreProjeto.recusado:
                                  return <Tag color='errorColor'>Orientação não aceita</Tag>;
                                default:
                                  return <Tag color='primaryColor'>Seleção pendente</Tag>;
                              }
                            })()}
                          </StyledTags>
                        </ListItemActions>
                      </ListItem>
                    ))}
                  </PreProjetoCardWithState>
                  <ChangePage
                    page={preProjetosRecusadosListQuery.pageRecusados}
                    pageSize={preProjetosRecusadosListQuery.pageSizeRecusados}
                    length={preProjetosRecusados && preProjetosRecusados.length}
                    changePage={this.changePagePreProjetoRecusados} />
                </TabPanel>
                <TabPanel titulo='Parâmetros'>
                  <PreProjetoCardWithState
                    state={parametrosListState}
                    noContent={'Nenhum parâmetro encontrado'}>
                    <StyledCardActions>
                      <Button icon='add'
                        onClick={() => {
                          window.location.pathname = `${this.props.match.path}/parametro`
                        }}>
                        Novo
                      </Button>
                    </StyledCardActions>
                    {parametrosList && parametrosList.map((p, i) => (
                      <ListItem key={i}
                        onClick={() => {
                          window.location.pathname = `${this.props.match.path}/parametro/${p.id}`
                        }}>
                        <ListItemTitle><b>Pré-Projeto Ano: </b>{format(p.dataDeInicio, 'YYYY')} <b> - Serie: </b> {p.serie}º ano</ListItemTitle>
                        <ListItemText><b>Período:</b> {format(p.dataDeInicio, 'DD/MM/YYYY')} - {format(p.dataDeFim, 'DD/MM/YYYY')}</ListItemText>
                      </ListItem>
                    ))}
                  </PreProjetoCardWithState>
                </TabPanel>
              </TabComponent>
            </TabPanel>
            <TabPanel titulo='Depósitos' subtitulo='Aceitos'>
              <MonografiasCardWithState
                state={monografiaListState}
                noContent='Nenhum TCC com agendamento pendente'
              >
                {monografias &&
                  monografias.map((m, idx) => (
                    <ListItem
                      onClick={() => {
                        window.location.pathname = `${this.props.match.path}/agendamento/${m.id}`;
                      }}
                      key={idx}
                    >
                      <ListItemTitle>{m.aluno.nome}</ListItemTitle>
                      <ListItemText>{m.titulo}</ListItemText>
                      <ListItemActions>
                        {m.agendamento ?
                          <Tag color='approvedColor'>Agendamento efetuado</Tag>
                          :
                          <Tag color='primaryColor'>Agendamento pendente</Tag>
                        }
                      </ListItemActions>
                    </ListItem>
                  ))}
              </MonografiasCardWithState>
              <ChangePage
                page={monografiaListQuery.page}
                pageSize={monografiaListQuery.pageSize}
                length={monografias.length}
                changePage={this.changePageMonografia} />
            </TabPanel>
            <TabPanel titulo='Alunos'>
              <AlunosCardWithState state={alunoListState} >
                {alunos &&
                  alunos.map((a, idx) => (
                    <ListItem onClick={() => {
                      window.location.pathname = `${this.props.match.path}/alunos/${a.id}`;
                    }}
                      key={idx}>
                      <ListItemTitle>{a.nome}</ListItemTitle>
                      <ListItemText>{a.matricula}</ListItemText>
                      <ListItemActions>
                        {!a.alunoAtivo &&
                          <Tag color='errorColor'>Aluno Desativado</Tag>
                        }
                      </ListItemActions>
                    </ListItem>
                  ))}
              </AlunosCardWithState>
              <ChangePage
                page={alunoListQuery.page}
                pageSize={alunoListQuery.pageSize}
                length={alunos.length}
                changePage={this.changePageAluno} />
            </TabPanel>
            <TabPanel titulo='Professores'>
              <ProfessorCardWithState state={professoresState} >
                {professores &&
                  professores.map((p, idx) => (
                    <ListItem onClick={() => {
                      window.location.pathname = `${this.props.match.path}/professor/${p.id}`
                    }}
                      key={idx}>
                      <ListItemTitle>{p.nome}</ListItemTitle>
                      <ListItemActions>
                        {!p.ativo &&
                          <Tag color='errorColor'>Professor Desativado</Tag>
                        }
                      </ListItemActions>
                    </ListItem>
                  ))}
              </ProfessorCardWithState>
              <ChangePage
                page={professorListQuery.page}
                pageSize={professorListQuery.pageSize}
                length={professores.length}
                changePage={this.changePageProfessor} />
            </TabPanel>
          </TabComponent>
        </Card>
      </>
    );
  }
}
export default React.memo(ListaMonografiasPage);
